import { CheckBadge } from "./CheckBadge";

type Props = {
  isActive: boolean;
  label: string;
  onClick: () => void;
};

export function OptionButton(props: Props) {
  return (
    <button
      type="button"
      onClick={props.onClick}
      aria-pressed={props.isActive}
      className={[
        "option-button",
        props.isActive ? "option-button--active" : "",
      ]
        .filter(Boolean)
        .join(" ")}
    >
      <span className="option-button__label">{props.label}</span>
      {props.isActive && <CheckBadge className="option-button__check" />}
    </button>
  );
}
